import React from 'react';
import { Building2, Wrench, Truck, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';

const poles = [
  {
    id: 'btp',
    icon: Building2,
    title: 'BTP & Génie Civil',
    intro: "Travaux de terrassement, génie civil et construction réalisés avec exigence, sécurité et performance.",
    image: 'https://images.unsplash.com/photo-1503708928676-1cb796a0891e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    color: 'green',
    activities: [
      'Terrassement',
      'Génie civil',
      'Construction',
      'Réhabilitation',
      'VRD',
      'Plateformes industrielles',
      'Aménagements extérieurs',
    ],
  },
  {
    id: 'mecanique-hydraulique',
    icon: Wrench,
    title: 'Mécanique & Hydraulique',
    intro: "Réparation, maintenance, vérins, tournage et solutions hydrauliques pour optimiser la performance de vos équipements.",
    image: 'https://images.unsplash.com/photo-1565954786194-d22abeaac3ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    color: 'orange',
    activities: [
      'Réparation mécanique',
      'Maintenance mécanique',
      'Tournage',
      'Usinage de pièces mécaniques',
      'Vérins hydrauliques',
      'Réparation de vérins',
      'Fabrication de flexibles hydrauliques',
      'Réparation hydraulique',
      'Fourniture de composants hydrauliques',
      'Intervention sur site',
    ],
  },
  {
    id: 'location',
    icon: Truck,
    title: 'Location de Matériel',
    intro: "Des équipements fiables et disponibles pour accompagner efficacement vos projets et vos chantiers.",
    image: 'https://images.unsplash.com/photo-1603814744450-36f978490b11?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200',
    color: 'green',
    activities: [
      "Location d'engins de chantier",
      'Location de matériels de terrassement',
      'Location de groupes électrogènes',
      'Location de matériels industriels',
      "Location d'équipements spécialisés",
      'Mise à disposition pour projets BTP et industriels',
    ],
  },
];

export const PolesServices = () => {
  const scrollToContact = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="produits" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Produits & <span className="text-green-600">Services</span>
          </h2>
          <p className="text-lg text-gray-700">
            Une expertise complète structurée autour de trois pôles d'activités.
          </p>
        </div>

        <div className="space-y-20">
          {poles.map((pole, index) => {
            const accent = pole.color === 'green' ? 'text-green-600' : 'text-orange-500';
            const accentBg = pole.color === 'green' ? 'bg-green-600' : 'bg-orange-500';
            const accentBtn = pole.color === 'green' ? 'bg-green-600 hover:bg-green-700' : 'bg-orange-500 hover:bg-orange-600';
            const reverse = index % 2 === 1;
            return (
              <div
                key={pole.id}
                id={pole.id}
                data-testid={`pole-${pole.id}`}
                className="scroll-mt-28 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center"
              >
                <div className={`relative h-80 rounded-2xl overflow-hidden shadow-xl ${reverse ? 'lg:order-2' : ''}`}>
                  <img src={pole.image} alt={pole.title} className="w-full h-full object-cover" />
                  <div className={`absolute top-4 left-4 p-3 rounded-full ${accentBg}`}>
                    <pole.icon className="h-6 w-6 text-white" />
                  </div>
                </div>

                <div className={reverse ? 'lg:order-1' : ''}>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">
                    {pole.title.split(' ')[0]}{' '}
                    <span className={accent}>{pole.title.split(' ').slice(1).join(' ')}</span>
                  </h3>
                  <p className="text-lg text-gray-700 mb-6 leading-relaxed">{pole.intro}</p>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
                    {pole.activities.map((a) => (
                      <div key={a} className="flex items-start gap-2">
                        <CheckCircle2 className={`h-5 w-5 flex-shrink-0 mt-0.5 ${accent}`} />
                        <span className="text-gray-700">{a}</span>
                      </div>
                    ))}
                  </div>

                  <Button onClick={scrollToContact} className={`text-white ${accentBtn}`} data-testid={`pole-cta-${pole.id}`}>
                    Demander un devis
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-green-50 to-orange-50 rounded-2xl p-8 max-w-2xl mx-auto">
            <p className="text-gray-800 font-medium">
              Un besoin spécifique non listé ? Contactez-nous pour une solution sur mesure.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
